import styles from "./NoticeThree.module.css";
import { useState, useEffect } from "react";
import { toCamelCase } from "../../Hooks/utility";
import { usePreviewStores } from "../../data/CmsPreviewContext";
import useDetermineAndCleanJSXOutput from "../../Hooks/useDetermineAndCleanJSXOutput";
import useShortCodes from "../../Hooks/useShortCodes";
import { pickContentByType } from "../../data/contentPicker";

const NoticeThree = () => {
  const { content } = usePreviewStores();
  const [noticeThreeData, setNoticeThreeData] = useState({});
  const shortCodes = useShortCodes();
  const textOne = shortCodes({ text: noticeThreeData.text, styles });
  const textTwo = shortCodes({ text: noticeThreeData.textTwo, styles });
  const textThree = shortCodes({ text: noticeThreeData.textThree, styles });
  const textFour = shortCodes({ text: noticeThreeData.textFour, styles });
  const determineAndCleanJSXOutput = useDetermineAndCleanJSXOutput();

  useEffect(() => {
    setNoticeThreeData(pickContentByType(content, "noticeThree") || {});
  }, [content]);

  // Assemble user-supplied image css
  const imageCSSNamesArray = [
    "imageOneCSS",
    "imageTwoCSS",
    "imageThreeCSS",
    "imageFourCSS",
  ];
  const imageCSS = [];

  if (noticeThreeData) {
    for (const imageCSSName of imageCSSNamesArray) {
      if (Object.hasOwn(noticeThreeData, imageCSSName)) {
        imageCSS[imageCSSName] = {};
        const imageCSSNameValueArray = noticeThreeData[imageCSSName]
          .replaceAll('"', "")
          .replaceAll("\n", "")
          .split("|");

        imageCSSNameValueArray.forEach((nameAndValue) => {
          if (!nameAndValue) return;
          const name = toCamelCase(
            nameAndValue.split(":")[0].replaceAll(" ", ""),
          );

          let value = nameAndValue.split(":")[1].trim();
          imageCSS[imageCSSName][name] = value;
        });
      }
    }
  }
  ///////

  return (
    <div className={styles["noticeThree-container"]}>
      <div className={styles["noticeThree-text-container"]}>
        {(noticeThreeData.imageOneURL || noticeThreeData.title) && (
          <div className={styles["title-container"]}>
            {noticeThreeData.imageOneURL && (
              <div className={styles["image-wrap"]}>
                <figure>
                  <img
                    src={noticeThreeData.imageOneURL}
                    className={
                      styles["image"] +
                      " " +
                      styles["image-one"] +
                      " " +
                      styles["content"]
                    }
                    style={{ ...imageCSS.imageOneCSS }}
                    alt={noticeThreeData.title + " first image "}
                  />
                </figure>
              </div>
            )}
            {noticeThreeData.title && (
              <div className={styles["sub-title-background"]}>
                {" "}
                <a
                  name="noticeThree"
                  href="#noticeThree"
                  className={styles["anchor-page-bookmark"]}
                >
                  <span></span>
                </a>
                <h3 className={`sub-title ${styles["sub-title"]}`}>
                  {noticeThreeData.title}
                </h3>{" "}
              </div>
            )}
          </div>
        )}
        {noticeThreeData.text && (
          <p
            className={
              styles["text"] +
              " " +
              styles["text-one"] +
              " " +
              styles["content"]
            }
          >
            {determineAndCleanJSXOutput(textOne)}
          </p>
        )}
        {(noticeThreeData.imageOneURL || noticeThreeData.textTwo) && (
          <div
            className={
              styles["text-pic-container"] +
              " " +
              styles["text-pic-container-two"]
            }
          >
            {" "}
            {noticeThreeData.imageTwoURL && (
              <div className={styles["image-wrap"]}>
                <figure>
                  <img
                    src={noticeThreeData.imageTwoURL}
                    className={
                      styles["image"] +
                      " " +
                      styles["image-two"] +
                      " " +
                      styles["content"]
                    }
                    alt={noticeThreeData.title + " second image "}
                    style={{ ...imageCSS.imageTwoCSS }}
                  />
                </figure>
              </div>
            )}{" "}
            {noticeThreeData.textTwo && (
              <p
                className={
                  styles["text"] +
                  " " +
                  styles["text-two"] +
                  " " +
                  styles["content"]
                }
              >
                {determineAndCleanJSXOutput(textTwo)}
              </p>
            )}{" "}
          </div>
        )}
        {(noticeThreeData.imageThreeURL || noticeThreeData.textThree) && (
          <div
            className={
              styles["text-pic-container"] +
              " " +
              styles["text-pic-container-three"]
            }
          >
            {noticeThreeData.textThree && (
              <p
                className={
                  styles["text"] +
                  " " +
                  styles["text-three"] +
                  " " +
                  styles["content"]
                }
              >
                {determineAndCleanJSXOutput(textThree)}
              </p>
            )}
            {noticeThreeData.imageThreeURL && (
              <div className={styles["image-wrap"]}>
                <figure>
                  <img
                    src={noticeThreeData.imageThreeURL}
                    className={
                      styles["image"] +
                      " " +
                      styles["image-three"] +
                      " " +
                      styles["content"]
                    }
                    alt={noticeThreeData.title + " third image "}
                    style={{ ...imageCSS.imageThreeCSS }}
                  />
                </figure>
              </div>
            )}
          </div>
        )}
        {(noticeThreeData.imageFourURL || noticeThreeData.textFour) && (
          <div
            className={
              styles["text-pic-container"] +
              " " +
              styles["text-pic-container-four"]
            }
          >
            {" "}
            {noticeThreeData.textFour && (
              <p
                className={
                  styles["text"] +
                  " " +
                  styles["text-four"] +
                  " " +
                  styles["content"]
                }
              >
                {determineAndCleanJSXOutput(textFour)}
              </p>
            )}
            {noticeThreeData.imageFourURL && (
              <div className={styles["image-wrap"]}>
                <figure>
                  <img
                    src={noticeThreeData.imageFourURL}
                    className={
                      styles["image"] +
                      " " +
                      styles["image-four"] +
                      " " +
                      styles["content"]
                    }
                    alt={noticeThreeData.title + " fourth image "}
                    style={{ ...imageCSS.imageFourCSS }}
                  />
                </figure>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoticeThree;
